import { Button, Checkbox, Grid } from '@scuf/common';
import useFetch from 'helpers/hooks/useFetch';
import { PartnersModel } from 'models/spareParts';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { USER_MANAGER, companyAtom } from 'resources';

const UsersOptions: React.FC = () => {
    const [company, setCompany] = useRecoilState<PartnersModel>(companyAtom);
    const { t } = useTranslation(['usermanager', 'common']);
    const handleChange = (field: string, value: any): void => {
        setCompany(old => ({ ...old, [field]: value }));
    };
    const [, setCustomerOptions, loading] = useFetch<PartnersModel>({
        url: USER_MANAGER.setCustomerOptions,
        method: 'POST',
        onError: 'Change',
        onSuccess: 'Change'
    });
    const handleSave = async (): Promise<void> => {
        await setCustomerOptions(company);
    };
    return (
        <>
            <h3>Spare Parts</h3>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Checkbox
                            label={t('usermanager:translation.GenerateMaintenanceReport')}
                            toggle={true}
                            checked={company.FlagAllowPerformanceReport}
                            onChange={(e: any, value: any) => {
                                handleChange('FlagAllowPerformanceReport', value);
                            }}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <h3>{t('Repair Center')}</h3>
            <Grid>
                <Grid.Column width={12}>
                    <Checkbox
                        label={t('usermanager:translation.PurchaseOrder')}
                        toggle={true}
                        checked={company.FlagPossuiPedidoCompraFaturamento}
                        onChange={(value: any) => handleChange('FlagPossuiPedidoCompraFaturamento', value)}
                    />
                </Grid.Column>
                <Grid.Column width={12}>
                    <Checkbox
                        label={t('usermanager:translation.DateReceiptNotes')}
                        toggle={true}
                        checked={company.FlagPossuiDataCorteRecebimentoNotas}
                        onChange={(value: any) => handleChange('FlagPossuiDataCorteRecebimentoNotas', value)}
                    />
                </Grid.Column>
                <Grid.Column width={12}>
                    <Checkbox
                        label={t('usermanager:translation.HasServiceFailure')}
                        toggle={true}
                        checked={company.FlagPossuiFolhaServicos}
                        onChange={(value: any) => handleChange('FlagPossuiFolhaServicos', value)}
                    />
                </Grid.Column>
                <Grid.Column width={12}>
                    <Checkbox
                        label={t('usermanager:translation.CNPJdifferentBilling')}
                        toggle={true}
                        checked={company.FlagPossuiCnpjDiferenteFaturamento}
                        onChange={(value: any) => handleChange('FlagPossuiCnpjDiferenteFaturamento', value)}
                    />
                </Grid.Column>
                <Grid.Column width={12}>
                    <Checkbox
                        label={t('usermanager:translation.ChargeOnlyServices')}
                        toggle={true}
                        checked={company.FlagRecebeFaturamentoSomenteServicos}
                        onChange={(value: any) => handleChange('FlagRecebeFaturamentoSomenteServicos', value)}
                    />
                </Grid.Column>
                <Grid.Column width={12}>
                    <Checkbox
                        label={t('usermanager:translation.RepairCenterPartner')}
                        toggle={true}
                        checked={company.FlagRepairCenterPartner}
                        onChange={(value: any) => handleChange('FlagRepairCenterPartner', value)}
                    />
                </Grid.Column>
            </Grid>
            <div className="buttonsSearch">
                <Button loading={loading} onClick={handleSave}>
                    {' '}
                    {t('common:actions.Save')}
                </Button>
            </div>
        </>
    );
};

export default UsersOptions;
